<template>
    <div id="errorMessage">
        <div class="icon">
            <img :src="icon" alt="expresion">
        </div>
        <div class="body">
            <h2>Something is wrong!</h2>
            <p>{{message}}</p>
            <span>{{name}}</span>
        </div>
    </div>
</template>

<script>
    import e0 from "../../assets/status/0.png";
    import e401 from "../../assets/status/401.png";
    import e403 from "../../assets/status/403.png";
    import e404 from "../../assets/status/404.png";
    import e500 from "../../assets/status/500.png";

    export default {
        props: {
            Exception: Error
        },
        watch: {
            Exception : {
                handler: function (nw) {
                    if(nw) {
                        this.setDetails(nw.message, nw.name);
                    }
                }
            }
        },
        data() {
            return {
                message: "",
                name: "",
                icon: ""
            }
        },
        methods: {
            setDetails(message, name) {
                this.message = message;
                this.name = name;
                this.icon = this.resolveIcon();
            },
            resolveIcon() {
                if(this.Exception) {
                    if(this.Exception.message.toLowerCase() == "network error") {
                        return e0;
                    } else if (this.Exception.message.includes("401")) {
                        return e401;
                    } else if (this.Exception.message.includes("403")) {
                        return e403;
                    } else if (this.Exception.message.includes("404")) {
                        return e404;
                    } else if (this.Exception.message.includes("500")) {
                        return e500;
                    } else {
                        return e0;
                    }
                }
            }
        },
        mounted() {
            this.$emit("ready", this.setDetails);
        }
    }
</script>

<style scoped lang="scss">
#errorMessage {
    display: flex;
    border: 1px solid rgba(62, 62, 62, 0.376);
    border-left: 5px solid rgb(235, 0, 0);
    box-shadow: 2px 0px 5px rgba(0, 0, 0, 0.406);
    margin: auto 0 auto 0;
    padding: 15px;
    width: 380px;
    height: 110px;
    color: #000;
      /* From https://css.glass */
    background: rgba(255, 255, 255, 0.4);
    -webkit-backdrop-filter: blur(6.2px);
    backdrop-filter: blur(6.2px);

    .icon {
        width: 102px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-left: 3px;
        padding-right: 18px;
        img {
            min-height: 100px;
            min-width: 100px;
            border-radius: 50%;
        }
    }
    .body {
        width: 75%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        span {
            color: rgba(44, 44, 44, 0.8);
            font-weight: bold;
            margin-top: 8px;
        }

        p {
            margin-top: 3px;
            font-size: 13px;
            word-break: break-all;
        }

        h2 {
            margin: 0 0 5px 0;
        }
    }
}
</style>